import { css } from '@inter-ikea-kompis/web-component';
import { ThemeBreakpointEnum } from '@inter-ikea-kompis/enums';
import type { ITheme } from '@inter-ikea-kompis/types';

import { Text } from '@ingka/common-styles-webc';

/**
 * This is the style class for SummaryPageSecurity.
 */
export default class SummaryPageSecurityStyle {
	/**
	 * Returns styles.
	 *
	 * @param options ...
	 * @param options.theme ...
	 */
	public static getStyle(options: { theme: ITheme }): string {
		const { spacing, color } = options.theme;

		return css`
			${Text.CSS}

			div {
				display: flex;
				flex-direction: column;
				gap: ${spacing.space150 / 16}rem;
			}

			.title {
				color: ${color.text.dark};
			}

			.no-margin {
				margin: 0;
			}

			${this.getGridLayoutForBreakpoint(options.theme, ThemeBreakpointEnum.medium)}
			${this.getGridLayoutForBreakpoint(options.theme, ThemeBreakpointEnum.large)}
			${this.getGridLayoutForBreakpoint(options.theme, ThemeBreakpointEnum.xlarge)}
			${this.getGridLayoutForBreakpoint(options.theme, ThemeBreakpointEnum.xxlarge)}
		`;
	}

	private static getGridLayoutForBreakpoint(
		theme: ITheme,
		breakpoint: Exclude<ThemeBreakpointEnum, ThemeBreakpointEnum.small>
	): string {
		const numberOfColumns = {
			[ThemeBreakpointEnum.medium]: 6,
			[ThemeBreakpointEnum.large]: 7,
			[ThemeBreakpointEnum.xlarge]: 7,
			[ThemeBreakpointEnum.xxlarge]: 7
		};

		const imageColumnWidth = {
			[ThemeBreakpointEnum.medium]: 5,
			[ThemeBreakpointEnum.large]: 6,
			[ThemeBreakpointEnum.xlarge]: 5,
			[ThemeBreakpointEnum.xxlarge]: 5
		};

		return css`
			@media (min-width: ${theme.breakpoint[breakpoint].width / 16}rem) {
				div {
					display: grid;
					grid-template-columns: repeat(${numberOfColumns[breakpoint]}, 1fr);
					column-gap: ${theme.breakpoint[breakpoint].gridSpacing.gutter / 16}rem;
				}
				kompis-image {
					grid-column: 1 / span ${imageColumnWidth[breakpoint]};
				}
				.title,
				.description {
					grid-column: 1 / span ${numberOfColumns[breakpoint]};
				}
			}
		`;
	}
}
